import query from 'marketplace-front-core/middleware/query'

export default query
